import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import Seo from '@/components/base/Seo';
import Breadcrumbs from '@/components/base/Breadcrumbs';
import FaqAccordion from '@/components/feature/FaqAccordion';
import { faqs } from '@/mocks/faqs';
import { site } from '@/mocks/site';

export default function FaqPage() {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const jsonLd = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: `${origin}/` },
        { '@type': 'ListItem', position: 2, name: '常见问题', item: `${origin}/faq` },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer },
      })),
    },
  ];

  return (
    <PageShell>
      <Seo
        title="常见问题 | 内容来源、隐私保护与维权步骤 - 职镜观察"
        description="职镜观察常见问题解答：内容来源与核实方式、投稿隐私保护、事实更正机制、薪资与补偿数字的参考范围，以及遇到劳动纠纷时可以先做的几件事。"
        keywords="职镜观察常见问题,投稿隐私,内容来源,事实更正,劳动维权步骤"
        jsonLd={jsonLd}
      />

      <div className="border-b border-background-200 bg-background-100 paper-grain">
        <div className="mx-auto max-w-content px-4 pb-10 pt-8 md:px-6 md:pb-14 md:pt-10">
          <Breadcrumbs items={[{ name: '首页', path: '/' }, { name: '常见问题' }]} />
          <p className="font-label text-xs tracking-[0.28em] text-primary-600">QUESTIONS &amp; ANSWERS</p>
          <h1 className="mt-3 max-w-3xl font-heading text-2xl font-black leading-snug text-foreground-950 md:text-4xl">
            常见问题：先把规则和边界讲清楚
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里汇总了读者最常问的问题，涉及内容从哪里来、投稿会不会暴露身份、发现内容有误怎么办，
            以及遇到薪资纠纷时可以先做的准备。
          </p>
        </div>
      </div>

      <div className="mx-auto grid max-w-content gap-10 px-4 py-10 md:px-6 md:py-14 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-8">
          <FaqAccordion items={faqs} />
        </div>

        <aside className="lg:col-span-4">
          <div className="space-y-6 lg:sticky lg:top-28">
            <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-lg text-primary-600" />
                <h2 className="font-heading text-base font-bold text-foreground-950">没有找到答案？</h2>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                可以直接发邮件给我们，说明你的问题与背景，我们会在{site.replyTime}内回复。
              </p>
              <a
                href={`mailto:${site.email}`}
                className="mt-4 inline-flex items-center gap-2 font-label text-sm text-primary-700 transition-colors hover:text-primary-500"
              >
                <i className="ri-mail-line text-base" />
                {site.email}
              </a>
            </div>

            <div className="rounded-lg bg-foreground-950 p-5 md:p-6">
              <i className="ri-shield-check-line text-2xl text-accent-400" />
              <h2 className="mt-3 font-heading text-base font-bold text-background-50">投稿前请放心</h2>
              <p className="mt-2 text-sm leading-relaxed text-background-300">
                我们默认对投稿人身份做脱敏处理，不会公开姓名、工号与联系方式，也不会把线索转给第三方。
              </p>
              <Link
                to="/contact"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 transition-colors hover:bg-primary-600"
              >
                前往投稿页面
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </aside>
      </div>
    </PageShell>
  );
}